import { action, observable } from 'mobx';
import { UPDATE_VIDEO_PROGRESS_POLLING_MS } from 'config/constants';
import ProgressStore from 'stores/Progress';

class WidgetVideoStore {
  @observable interval: NodeJS.Timeout;

  @observable timestamp: number;

  @observable currentVideo: string;

  @observable userProgressPageDocId: string;

  @observable progressStore: ProgressStore;

  constructor(progressStore: ProgressStore) {
    this.progressStore = progressStore;
  }

  @action startPolling() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.interval = setInterval(() => {
      this.saveProgress();
    }, UPDATE_VIDEO_PROGRESS_POLLING_MS);
  }

  @action stopPolling() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.saveProgress();
  }

  @action updateProgress(player) {
    this.timestamp = player.normalizedCurrentTime;
    this.currentVideo = player.sources.id;
    this.userProgressPageDocId = this.progressStore.userProgressPage.doc_id;
  }

  @action saveProgress() {
    if (this.timestamp && this.currentVideo && this.userProgressPageDocId) {
      this.progressStore.updateVideoProgressInPage(
        this.userProgressPageDocId,
        this.currentVideo,
        this.timestamp,
      );
    }
  }
}

export default WidgetVideoStore;
